import { GlType, RegulatoryType } from '~/types/account';
import { ProfileType } from '~/types/profile';
import hasTranslation from './hasTranslation';

export const glTypeLabel = (code: GlType | string): string =>
  `components.ra.fields.GlTypeIcon.${code}`;

export const regulatoryTypeLabel = (code: RegulatoryType | string): string =>
  `components.ra.fields.RegulatoryType.${code}`;

export const translateBalanceCode = (
  translate: (key: string) => string,
  code: string,
  profileType?: ProfileType
): string => {
  const prefix =
    profileType === 'INDIVIDUAL' ? 'individuals_' : profileType === 'TENANT' ? 'tenant_' : '';
  const prefixedKey = `utils.balances.code.${prefix}${code}`;
  if (prefix && hasTranslation(prefixedKey)) return translate(prefixedKey);
  const defaultKey = `utils.balances.code.${code}`;
  return hasTranslation(defaultKey) ? translate(defaultKey) : code;
};
